// Error message mapping for user-friendly display
export const getErrorMessage = (error: any): string => {
  const errorMessage = error?.message || error?.toString() || 'An unexpected error occurred';
  
  // Authentication errors
  if (errorMessage.includes('Invalid email or password')) {
    return 'Login failed. Please check your email and password and try again.';
  }
  
  if (errorMessage.includes('User already exists')) {
    return 'Account already exists with this email address.';
  }
  
  if (errorMessage.includes('Account is deactivated')) {
    return 'Your account has been deactivated. Please contact support for assistance.';
  }
  
  if (errorMessage.includes('Account needs password setup')) {
    return 'Account setup is incomplete. Please contact support for assistance.';
  }
  
  // Input validation errors
  if (errorMessage.includes('Email and password are required')) {
    return 'Please enter both email and password to continue.';
  }
  
  if (errorMessage.includes('Password must be at least 6 characters')) {
    return 'Password must be at least 6 characters long.';
  }
  
  if (errorMessage.includes('email') && errorMessage.includes('invalid')) {
    return 'Please enter a valid email address.';
  }
  
  // Network/connection errors
  if (errorMessage.includes('Network Error') || errorMessage.includes('fetch')) {
    return 'Connection failed. Please check your internet connection and try again.';
  }
  
  if (errorMessage.includes('timeout') || errorMessage.includes('TIMEOUT')) {
    return 'Request timed out. Please try again in a moment.';
  }
  
  // Server errors
  if (errorMessage.includes('Server Error') || errorMessage.includes('500')) {
    return 'Our servers are experiencing issues. Please try again later.';
  }
  
  if (errorMessage.includes('Service Unavailable') || errorMessage.includes('503')) {
    return 'Service is temporarily unavailable. Please try again later.';
  }
  
  // Rate limiting
  if (errorMessage.includes('rate limit') || errorMessage.includes('too many requests')) {
    return 'Too many attempts. Please wait a moment before trying again.';
  }
  
  // Convex specific errors
  if (errorMessage.includes('CONVEX')) {
    if (errorMessage.includes('loginUser')) {
      return 'Login failed. Please check your credentials and try again.';
    }
    if (errorMessage.includes('registerUser')) {
      return 'Account creation failed. Please try again.';
    }
    return 'Service error. Please try again later.';
  }
  
  // Generic fallbacks based on error types
  if (errorMessage.toLowerCase().includes('registration') || errorMessage.toLowerCase().includes('signup')) {
    return 'Account creation failed. Please check your information and try again.';
  }
  
  if (errorMessage.toLowerCase().includes('login') || errorMessage.toLowerCase().includes('signin')) {
    return 'Login failed. Please check your credentials and try again.';
  }
  
  // Default fallback
  return 'Something went wrong. Please try again or contact support if the issue persists.';
};

// Get specific error type for different handling
export const getErrorType = (error: any): 'auth' | 'network' | 'validation' | 'server' | 'unknown' => {
  const errorMessage = error?.message || error?.toString() || '';
  
  if (errorMessage.includes('Invalid email or password') || 
      errorMessage.includes('User already exists') ||
      errorMessage.includes('Account is deactivated')) {
    return 'auth';
  }
  
  if (errorMessage.includes('Network Error') || 
      errorMessage.includes('fetch') ||
      errorMessage.includes('timeout')) {
    return 'network';
  }
  
  if (errorMessage.includes('required') || 
      errorMessage.includes('must be') ||
      errorMessage.includes('invalid')) {
    return 'validation';
  }
  
  if (errorMessage.includes('Server Error') ||
      errorMessage.includes('500') ||
      errorMessage.includes('503')) {
    return 'server';
  }
  
  return 'unknown';
};
